const FREQUENCY_LABELS = { monthly: "Mensual", weekly: "Semanal", quarterly: "Trimestral", other: "Otra" };

export const AdminDistributionRequestsTable = ({ rows }) => (
  <div className="overflow-x-auto rounded-xl border border-white/10">
    <table className="w-full text-sm min-w-[1400px]" data-testid="admin-distribution-requests-table">
      <thead>
        <tr className="border-b border-white/10 text-neutral-500 text-xs uppercase tracking-wide">
          <th className="text-left font-medium px-4 py-3">Código</th>
          <th className="text-left font-medium px-4 py-3">Contacto</th>
          <th className="text-left font-medium px-4 py-3">Correo</th>
          <th className="text-left font-medium px-4 py-3">Teléfono</th>
          <th className="text-left font-medium px-4 py-3">Artista / Sello</th>
          <th className="text-left font-medium px-4 py-3">Catálogo</th>
          <th className="text-left font-medium px-4 py-3">Frecuencia</th>
          <th className="text-left font-medium px-4 py-3">Experiencia</th>
          <th className="text-left font-medium px-4 py-3">Objetivos</th>
          <th className="text-left font-medium px-4 py-3">Enlaces</th>
          <th className="text-left font-medium px-4 py-3">Fecha</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.code} data-testid={`admin-distribution-request-row-${r.code}`} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors align-top">
            <td className="px-4 py-3 font-mono text-xs text-neutral-400 whitespace-nowrap">{r.code}</td>
            <td className="px-4 py-3 font-semibold whitespace-nowrap">{r.contactName}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">{r.email}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">{r.phone}</td>
            <td className="px-4 py-3 text-neutral-300 whitespace-nowrap">{r.artistOrLabel}</td>
            <td className="px-4 py-3 text-neutral-400 max-w-[140px]">{r.catalogSize}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">{FREQUENCY_LABELS[r.releaseFrequency] || r.releaseFrequency}</td>
            <td className="px-4 py-3 text-neutral-400 max-w-[220px] whitespace-pre-wrap">{r.experience}</td>
            <td className="px-4 py-3 text-neutral-400 max-w-[220px] whitespace-pre-wrap">{r.goals}</td>
            <td className="px-4 py-3 text-neutral-400 max-w-[220px] whitespace-pre-wrap">{r.socialLinks}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">
              {r.submitted_at ? new Date(r.submitted_at).toLocaleString("es-MX") : "—"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
